enum NavigationActions {
  FETCH_LIST = "navigationFetchList",
  GET_ITEM = "navigationGetItem",
  CREATE_ITEM = "navigationCreateItem",
  UPDATE_ITEM = "navigationUpdateItem",
  UPDATE_ITEM_TRANSLATIONS = "navigationUpdateItemTranslations",
  DELETE_ITEM = "navigationDeleteItem",
  REFRESH_LIST = "navigationRefreshList",

  FETCH_GROUPS = "navigationFetchGroups",
  GET_GROUP = "navigationGetGroup",
  CREATE_GROUP = "navigationCreateGroup",
  UPDATE_GROUP = "navigationUpdateGroup",
  UPDATE_GROUP_RELATIONS = "navigationUpdateGroupRelations",
  DELETE_GROUP = "navigationDeleteGroup",
  REFRESH_GROUPS = "navigationRefreshListGroups",
}

enum NavigationMutation {
  SET_RENDER_UPDATE = "navigationListRenderNeeded",
  SET_LIST_RESULT = "navigationListResult",
  SET_GROUPS_LIST_RESULT = "navigationGroupsListResult",
}

export { NavigationActions, NavigationMutation };
